import { LinkedRequestListResponseSchema, type LinkedRequestListResponse } from '@magimp/shared';
import { request } from '../client.js';

/**
 * @aiPurpose `GET /leads/:id/requests` (#1596) — the actor-visible China
 *   request summaries linked to a Lead. Non-PII rows (code/status/SLA only).
 * @aiSecurity parent-visibility is enforced server-side (404 on invisible
 *   parent), then per-request visibility filters the rows.
 */
export function fetchLeadRequests(leadId: string): Promise<LinkedRequestListResponse> {
  return request<LinkedRequestListResponse>(
    `/leads/${encodeURIComponent(leadId)}/requests`,
    { method: 'GET' },
    {},
    LinkedRequestListResponseSchema,
  );
}

/**
 * @aiPurpose `GET /deals/:id/requests` (#1596) — the actor-visible China
 *   request summaries linked to a Deal. Mirrors `fetchLeadRequests`.
 */
export function fetchDealRequests(dealId: string): Promise<LinkedRequestListResponse> {
  return request<LinkedRequestListResponse>(
    `/deals/${encodeURIComponent(dealId)}/requests`,
    { method: 'GET' },
    {},
    LinkedRequestListResponseSchema,
  );
}
